module.exports = __webpack_public_path__ + "assets/img/00109.d6c9ec41.png";